// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
    display: flex;
    flex-direction: column;
    gap: 4rem;
    background-color: var(--tiles);
    border: none;
    border-radius: 2rem;
    color: var(--text);
    width: max(15%,10rem);
    font-family: 'Poppins', sans-serif;
    padding: 2%;
}

.segments {
    display: flex;
    flex-direction: column;
    gap:max(10px,1%);
    width:100%;
}

.element {
    display: flex;
    gap:1rem;
    font-size: 1.4rem;
    padding-left:10px;
    border-radius: 0.5rem;
    transition: background 0.5s;
    cursor:pointer;
}

.element:hover,.element.selected {
    background-color: var(--select);
    border-left: 2px solid var(--accent);
}

`, "",{"version":3,"sources":["webpack://./src/styles/nav-col.css"],"names":[],"mappings":"AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;AACxC","sourcesContent":["@import url(./themes.css);\r\n.nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4rem;\r\n    background-color: var(--tiles);\r\n    border: none;\r\n    border-radius: 2rem;\r\n    color: var(--text);\r\n    width: max(15%,10rem);\r\n    font-family: 'Poppins', sans-serif;\r\n    padding: 2%;\r\n}\r\n\r\n.segments {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:max(10px,1%);\r\n    width:100%;\r\n}\r\n\r\n.element {\r\n    display: flex;\r\n    gap:1rem;\r\n    font-size: 1.4rem;\r\n    padding-left:10px;\r\n    border-radius: 0.5rem;\r\n    transition: background 0.5s;\r\n    cursor:pointer;\r\n}\r\n\r\n.element:hover,.element.selected {\r\n    background-color: var(--select);\r\n    border-left: 2px solid var(--accent);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
